import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";

import { UPDATE_CUSTOMER_ADDRESS_LOCATION } from "../customer-address.queries";

import {
  UpdateCustomerAddressLocationMutation,
  UpdateCustomerAddressLocationMutationVariables,
} from "../../../__generated__/UpdateCustomerAddressLocationMutation";

export const useUpdateCustomerAddressLocation = () => {
  const [mutate, { loading }] = useMutation<
    UpdateCustomerAddressLocationMutation,
    UpdateCustomerAddressLocationMutationVariables
  >(UPDATE_CUSTOMER_ADDRESS_LOCATION, {
    refetchQueries: "active",
  });

  const captureLocation = async (id: number) => {
    if (!navigator.geolocation) {
      toast.error("La géolocalisation n'est pas disponible sur cet appareil");
      return false;
    }

    try {
      const position = await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 10000,
        });
      });

      const { data } = await mutate({
        variables: {
          id,
          input: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          },
        },
      });

      if (data?.updateCustomerAddressLocation?.ok) {
        toast.success("Position enregistrée");
        return true;
      }

      toast.error(data?.updateCustomerAddressLocation?.error ?? "Une erreur est survenue");
      return false;
    } catch (error: any) {
      toast.error(error?.message ?? "Impossible de récupérer la position");
      return false;
    }
  };

  return { captureLocation, loading };
};
